import { TreatmentModel } from 'src/components/messages/treatmentsModel';

class PatientsAnalysesTreatmentsModel extends TreatmentModel {
  id = 'PatientsAnalysesTreatmentsModel';
  constructor() {
    super();
  }
  _events = {
    profile: 'handleProfile',
    openPatientAnalyse: 'onOpenPatient',
    'foxsocket:message:treatment': 'onMessage'
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };
  listParams(loadMore) {
    const req = super.listParams(loadMore);

    if (!req) return null;

    return {
      ...req,
      patientId: req.partnerId
    };
  }
  onOpenPatient = (patient = null) => {
    if (!patient?.id) return;

    this.onOpenContact({
      contact: {
        ...patient,
        partnerId: patient.id
      }
    });
  };
}
const treatmentsModel = new PatientsAnalysesTreatmentsModel();

export default treatmentsModel;
